import { z } from "zod";
import { ConstructionRecordBaseSchema } from "../generated/ConstructionRecord";
import { getUserSchema } from "./user";

export const ConstructionRecordWithUserSchema = ConstructionRecordBaseSchema.base.extend({
  User: getUserSchema.strip(),
});
export type constructionRecordWithUser = z.infer<typeof ConstructionRecordWithUserSchema>;